export function getByKeyOrDefault<K extends string | number | symbol, T>(
  record: Record<K, T>,
  key: K | undefined,
  defaultValue: T
) {
  return (key ? record[key] : undefined) ?? defaultValue
}
